import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Apply from './pages/Apply';
import Login from './pages/Login';
import LeadList from './pages/LeadList';
import LeadDetail from './pages/LeadDetail';
import { getToken } from './api';

function RequireAuth({ children }) {
  return getToken() ? children : <Navigate to="/crm/login" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Apply />} />
        <Route path="/apply" element={<Apply />} />
        <Route path="/crm/login" element={<Login />} />
        <Route path="/crm" element={<RequireAuth><LeadList /></RequireAuth>} />
        <Route path="/crm/lead/:id" element={<RequireAuth><LeadDetail /></RequireAuth>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
